import { gql } from '@apollo/client'

export const WARM_AUDIENCES = gql`
    query WarmAudiences($publisherId: ID!, $campaignId: ID!, $objective: String!) {
        warmAudiences(publisher_id: $publisherId, campaign_id: $campaignId, objective: $objective) {
            available
            audiences {
                audience_id
                kind
                funnel_stage
                label
                retention_days
                status
                approximate_count_lower
                message
            }
        }
    }
`
